module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "page-table"
  }, [_c('div', {
    staticClass: "page-table-header"
  }, [_c('div', {
    staticClass: "page-table-header-title"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("运行状态\n                "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.getJobExecutors()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-table-header-separator"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "refresh-text"
  }, [_vm._v("自动刷新：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择",
      "size": "mini"
    },
    on: {
      "change": _vm.refreshExecutions
    },
    model: {
      value: (_vm.autoRefreshTime),
      callback: function($$v) {
        _vm.autoRefreshTime = $$v
      },
      expression: "autoRefreshTime"
    }
  }, _vm._l((_vm.refreshTimes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "border": "",
      "data": _vm.executions
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "item",
      "label": "分片项",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.statusTag[scope.row.status]
          }
        }, [_vm._v(_vm._s(_vm.translateStatus[scope.row.status]))]), _vm._v(" "), (scope.row.failover) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("failover")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "jobMsg",
      "label": "分片返回信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" \n                    " + _vm._s(scope.row.jobMsg) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "executorName",
      "label": "Executor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近执行时间",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("起:" + _vm._s(scope.row.lastBeginTime || ' ——'))]), _vm._v(" "), _c('div', [_vm._v("止:" + _vm._s(scope.row.lastCompleteTime || ' ——'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastTimeConsumedInSec",
      "label": "执行时长(秒)",
      "width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.lastTimeConsumedInSec === 0) ? _c('div', [_vm._v("——")]) : _c('div', [_vm._v(_vm._s(scope.row.lastTimeConsumedInSec))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nextFireTime",
      "label": "下次开始时间",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日志",
      "width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "查看日志",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.getLog(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text-o"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.isViewLogVisible) ? _c('div', [_c('ViewContentDialog', {
    attrs: {
      "title": "查看日志",
      "content": _vm.logContent
    },
    on: {
      "close-dialog": _vm.closeViewLogDialog
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f32c904"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_detail/job_execution.vue
// module id = 1406
// module chunks = 1